module.exports = __webpack_public_path__ + "78e8e6da1f00e1cf2e36bc3946441e37.svg";